// extracted by mini-css-extract-plugin
module.exports = {"container":"TitleSection_container__3GTQt"};